export const tableData = [
  {
    category: "Documents Required",
    student: [
      "10th, 12th, Graduation marksheets",
      "Degree certificate, PIB score",
    ],
    selfEmployed: [
      "KYC",
      "1 year ITR with computation",
      "Certificate of Practice / Business License + contracts",
      "Business Registration",
      "GST Registration",
      "Latest Electricity Bill",
    ],
    salaried: [
      "KYC",
      "Last 3 years slips",
      "Last 6-month bank statement",
      "Latest Electricity Bill",
    ],
    type: "list",
  },
  {
    category: "Electricity Bill",
    student: "Required",
    selfEmployed: "Required",
    salaried: "Required",
    type: "badge",
  },
  {
    category: "Co-applicant (Civil)",
    student: "Same income documents as for co-applicant",
    selfEmployed: "Same as above",
    salaried: "Same as above",
    type: "text",
  },
];

const loanTermsData = [
  {
    title: "Secured / Salaried Guarantor",
    range: "10.75% to 11.5%",
  },
  {
    title: "Unsecured Loan",
    range: "10% to 13.5%",
  },
];

export default loanTermsData;
